import { StyledTableCell } from "../style";

export default function Cell(args) {
  return <StyledTableCell {...args}>{args.content}</StyledTableCell>;
}
